module.exports = __webpack_public_path__ + "static/media/catalouge-35.c1c72aa2.jpg";